module.exports = __webpack_public_path__ + "img/personal_head_background.ebb73ee9.png";